import { TDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { trackJoinTradeClick, trackShowTradingWidgetModalClick } from './tracking';
import { ElectronicTradingButton } from '../../components/ElectronicTradesButton';
import { IFavoriteEntity } from '../../types/results';
import { useApplicationContext } from '../../utils/applicationContext';
import { parsePhoneNumber } from '../../utils/strings';

import type { ElectronicTradingWidgetProps } from '@cian/frontend-electronic-trading-widget';

interface IElectronicTradingButtonContainerProps {
  favoriteEntity: IFavoriteEntity;
  deviceType?: TDeviceType;
}

export const ElectronicTradingButtonContainer = (props: IElectronicTradingButtonContainerProps) => {
  const { config } = useApplicationContext();
  const { tradingLink, agentInfo } = props.favoriteEntity;

  const legalLink = config.getStrict<string>('electronicTrading.legalDocsUrl');

  const widgetProps: ElectronicTradingWidgetProps = {
    deviceType: props.deviceType ? props.deviceType : ('desktop' as TDeviceType),
    joinTradeButtonLink: tradingLink,
    legalLink,
    publisherAvatarSrc: agentInfo?.avatarUrl ?? null,
    publisherName: agentInfo?.name ?? '',
    publisherPhoneNumbers: agentInfo?.phones.map(parsePhoneNumber) ?? [],
    publisherTypeLabel: agentInfo?.formattedPublisherType ?? null,
    trackJoinTrade: () => trackJoinTradeClick(props.favoriteEntity),
    /**
     * Эти события трекать не требуется. Добавить, если требования поменяются.
     */
    trackLegalLinkClick: /* istanbul ignore next */ () => {},
    trackPublisherPhoneNumberClick: /* istanbul ignore next */ () => {},
  };

  return (
    <ElectronicTradingButton
      {...widgetProps}
      buttonText={'Принять участие в торгах'}
      trackShowTradingWidgetModal={() => trackShowTradingWidgetModalClick(props.favoriteEntity)}
    />
  );
};
